module.exports = __webpack_public_path__ + "05522d9c2a46782b5b0a75c2146748bc.svg";